<div *ngIf="this.isLoggedIn() === false">
  <div class="login" (click)="logout()">
    <img class="login-image" src="../../../../assets/images/login_logo.svg" alt="Representing Image">
    <div>
      <a class="login-font">{{loginText}}</a>
    </div>
  </div>
</div>


<div class="user-container" *ngFor="let user of onlineUsersProject">
  <div class="avatar-user" *ngIf="user.avatarImage !== me.avatarImage" [ngStyle]="{ 'background-image': 'url(' + user.avatarImage + ')'}" (click)=showUserProfil(user,false)></div>
</div>

<div class="avatar-me" *ngIf="me.avatarImage !== ''" [ngStyle]="{ 'background-image': 'url(' + me.avatarImage + ')'}" (click)=showUserProfil(me,true)></div>

